import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './StockOut.css';

function StockOut() {

    const navigate = useNavigate();

    const [materials, setMaterials] = useState([]);

    const [material_id, setMaterialId] = useState('');
    const [quantity, setQuantity] = useState('');

    const [stocklocation, setStockLocation] = useState('');
    const [otherLocation, setOtherLocation] = useState('');

    useEffect(() => {
        fetchMaterials();
    }, []);

    const fetchMaterials = async () => {

        try {

            const response = await axios.get(
                'https://ikaze-thouse-backend.vercel.app/api/v1/materials/getAll'
            );

            setMaterials(response.data.data);

        } catch (error) {
            console.log(error);
        }
    };

    const saveStockOut = async (e) => {

        e.preventDefault();

        const finalLocation =
            stocklocation === "Other"
                ? otherLocation
                : stocklocation;

        try {

            const response = await axios.post(
                'https://ikaze-thouse-backend.vercel.app/api/v1/materials/stockout',
                {
                    material_id,
                    quantity,
                    stocklocation: finalLocation
                }
            );

            alert(response.data.message);

            setMaterialId('');
            setQuantity('');
            setStockLocation('');
            setOtherLocation('');

            navigate('/all-Materials');

        } catch (error) {
            console.log(error);
            alert(error.response?.data?.message || "Stock Out Failed");
        }
    };

    return (

        <div className="stockout-container">

            <div className="stockout-card">

                <h2 className="title">Stock Out</h2>

                <form onSubmit={saveStockOut} className="stockout-form">

                    {/* MATERIAL */}
                    <div className="form-group">

                        <label>Select Material</label>

                        <select
                            value={material_id}
                            onChange={(e) => setMaterialId(e.target.value)}
                        >
                            <option value="">Select Material</option>

                            {
                                materials.map((item) => (
                                    <option
                                        key={item.material_id}
                                        value={item.material_id}
                                    >
                                        {item.materialname}
                                    </option>
                                ))
                            }

                        </select>

                    </div>

                    {/* QUANTITY */}
                    <div className="form-group">

                        <label>Quantity</label>

                        <input
                            type="number"
                            placeholder="Enter quantity"
                            value={quantity}
                            onChange={(e) => setQuantity(e.target.value)}
                        />

                    </div>

                    {/* LOCATION DROPDOWN */}
                    <div className="form-group">

                        <label>Stock Location</label>

                        <select
                            value={stocklocation}
                            onChange={(e) => setStockLocation(e.target.value)}
                        >
                            <option value="">Select Location</option>
                            <option value="In House">In House</option>
                            <option value="Other">Other</option>
                        </select>

                    </div>

                    {/* IF OTHER SELECTED */}
                    {stocklocation === "Other" && (
                        <div className="form-group">

                            <label>Specify Location</label>

                            <input
                                type="text"
                                placeholder="Enter custom location"
                                value={otherLocation}
                                onChange={(e) => setOtherLocation(e.target.value)}
                            />

                        </div>
                    )}

                    <button type="submit" className="submit-btn">
                        Save Stock Out
                    </button>

                </form>

            </div>

        </div>
    );
}

export default StockOut;